import * as React from "react";
import { Text } from "@grandvisionhq/elements";
import { useLink } from "@grandvisionhq/frk-routing";
import { H2 } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import OrderListItem from "./OrderListItem.js";
import { logOrderEvent } from "../../../../../../data-layer/data-layer/orders.js";
import { makeOrderDetailsClickEvent } from "../../../../../../data-layer/data-layer/utils.js";
const OrderListItemContainer = ({
  lineItems,
  orderDate,
  orderNumber,
  paymentStatus,
  shouldShowOrderDate = true
}) => {
  const { dateTime, getLabel } = useIntl();
  const { href, onClick } = useLink({ route: "me.orders.detail", params: { orderId: orderNumber } }) ?? {};
  const labels = {
    order: getLabel("common.order"),
    viewDetails: getLabel("account.common.viewDetails")
  };
  const handleOnClick = (e) => {
    logOrderEvent(makeOrderDetailsClickEvent("my_online_orders", orderNumber, paymentStatus));
    onClick?.(e);
  };
  return /* @__PURE__ */ React.createElement("div", { className: "order-list-item", key: orderNumber }, /* @__PURE__ */ React.createElement("div", { className: "order-list-item__header" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(H2, { className: "order-list-item__order-number", variant: "smallest" }, labels.order, " ", orderNumber)), shouldShowOrderDate && /* @__PURE__ */ React.createElement(Text, { variant: "body", color: "text-secondary" }, dateTime.formatMidsizeDate(orderDate))), lineItems.map((lineItem) => /* @__PURE__ */ React.createElement(
    OrderListItem,
    {
      key: `${lineItem.title}-${lineItem.subtitle}`,
      header: lineItem.title,
      subtitle: lineItem.subtitle,
      imageUrl: lineItem.imageUrl,
      href,
      onClick: handleOnClick,
      labels
    }
  )));
};
export {
  OrderListItemContainer as default
};
//# sourceMappingURL=OrderListItemContainer.js.map
